import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

function formatCount(n) {
  if (n >= 1000) {
    return `${(n / 1000).toFixed(n % 1000 === 0 ? 0 : 1)}k`;
  }
  return (Number(n) || 0).toLocaleString('id-ID');;
}

export default function PromoBannerActions({
  viewCount,
  liked,
  likeCount,
  commentCount,
  shareCount,
  onLike,
  onOpenLike,
  onComment,
  onShare,
  padded = false,
  showCommentLink = true,
}) {
  return (
    <View style={[styles.wrap, padded && styles.wrapPadded]}>
      <View style={styles.row}>
        <View style={styles.action}>
          <TouchableOpacity style={styles.iconBtn} onPress={()=>{}} activeOpacity={0.7} hitSlop={8}>
            <Ionicons name="eye-outline" size={22} color="#1E293B" />
          </TouchableOpacity>
          {viewCount > 0 && (
            <TouchableOpacity style={styles.iconBtn} onPress={()=>{}} activeOpacity={0.7} hitSlop={8}>
              <Text style={styles.actionLabel}>{formatCount(viewCount)}</Text>
            </TouchableOpacity>
          )}
        </View>
        <View style={styles.action}>
          <TouchableOpacity style={styles.iconBtn} onPress={onLike} activeOpacity={0.7} hitSlop={8}>
            <Ionicons
              name={liked ? 'heart' : 'heart-outline'}
              size={24}
              color={liked ? '#ED4956' : '#1E293B'}
            />
          </TouchableOpacity>
          {likeCount > 0 && (
            <TouchableOpacity style={styles.iconBtn} onPress={()=>{}} activeOpacity={0.7} hitSlop={8}>
              <Text style={styles.actionLabel}>{formatCount(likeCount)}</Text>
            </TouchableOpacity>
          )}
        </View>

        <View style={styles.action}>
          <TouchableOpacity style={styles.iconBtn} onPress={onComment} activeOpacity={0.7} hitSlop={8}>
            <Ionicons name="chatbubble-outline" size={22} color="#1E293B" />
          </TouchableOpacity>
          {commentCount > 0 && (
            <TouchableOpacity style={styles.iconBtn} onPress={onComment} activeOpacity={0.7} hitSlop={8}>
              <Text style={styles.actionLabel}>{formatCount(commentCount)}</Text>
            </TouchableOpacity>
          )}
        </View>

        <View style={styles.action}>
          <TouchableOpacity style={styles.iconBtn} onPress={onShare} activeOpacity={0.7} hitSlop={8}>
            <Ionicons name="paper-plane-outline" size={22} color="#1E293B" />
          </TouchableOpacity>
          {shareCount > 0 && (
            <TouchableOpacity style={styles.iconBtn} onPress={onShare} activeOpacity={0.7} hitSlop={8}>
              <Text style={styles.actionLabel}>{formatCount(shareCount)}</Text>
            </TouchableOpacity>
          )}  
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    paddingTop: 4,
    paddingHorizontal: 8,
    gap: 2,
  },
  wrapPadded: {
    paddingHorizontal: 16,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 14,
  },
  action: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  actionLabel: {
    fontSize: 13,
    fontFamily: 'Poppins-Medium',
    fontWeight: '500',
    color: '#0F172A',
    lineHeight: 18,
  },
  iconBtn: {
    paddingVertical: 2,
  },
  likes: {
    fontSize: 13,
    fontFamily: 'Poppins-SemiBold',
    fontWeight: '600',
    color: '#0F172A',
    lineHeight: 18,
  },
  viewComments: {
    fontSize: 13,
    fontFamily: 'Poppins',
    color: '#64748B',
    lineHeight: 18,
  },
});
